module.exports = __webpack_public_path__ + "static/ipo1-81513d54dccf8ae742f1973b6aa90238.jpg";